import { render } from "./PriorityIndicator.vue?vue&type=template&id=5dbb85ec&scoped=true"
import script from "./PriorityIndicator.vue?vue&type=script&lang=js"
export * from "./PriorityIndicator.vue?vue&type=script&lang=js"

import "./PriorityIndicator.vue?vue&type=style&index=0&id=5dbb85ec&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbb85ec"]])

export default __exports__